<div class="-tw-ml-2">
  <div class="tw-inline-flex tw-items-center form-check" [formGroup]="form">
    <label
      class="tw-relative tw-flex tw-items-center tw-p-3 tw-rounded-full tw-cursor-pointer"
      for="checkbox"
      data-ripple-dark="true"
      [attr.ng-reflect-name]="!!controlArray ? controlArray : ''"
    >
      <input
        type="checkbox"
        class="before:tw-content[''] form-check-input tw-peer tw-relative tw-h-6 tw-w-6 tw-cursor-pointer tw-appearance-none tw-rounded-md tw-border-2 tw-border-blue-gray-200 tw-transition-all before:tw-absolute before:tw-top-2/4 before:tw-left-2/4 before:tw-block before:tw-h-12 before:tw-w-12 before:-tw-translate-y-2/4 before:-tw-translate-x-2/4 before:tw-rounded-full before:tw-bg-blue-gray-500 before:tw-opacity-0 before:tw-transition-opacity {{
          props
        }} tw-border-[3px] hover:before:tw-opacity-10"
        id="checkbox"
        [checked]="checked"
        [value]="value"
        (change)="handleCheckboxSelected($event)"
        [formControlName]="controlName"
      />
      <div
        class="tw-absolute tw-text-white tw-transition-opacity tw-opacity-0 tw-pointer-events-none tw-top-2/4 tw-left-2/4 -tw-translate-y-2/4 -tw-translate-x-2/4 peer-checked:tw-opacity-100"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="1"
        >
          <path
            fill-rule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
    </label>
    <span class="tw-font-light tw-text-gray-700">
      @if (isStringLabel) {
        {{ label }}
      } @else {
        <ng-container [ngTemplateOutlet]="label"></ng-container>
      }
    </span>
  </div>
  <div
    class="tw-ml-3 tw-text-sm  tw-flex tw-items-center tw-gap-1 {{
      isError ? 'tw-text-red-500' : ''
    }}"
  >
    @if (isError) {
      <span class="material-icons tw-mr-1 tw-text-xl">error_outline</span>
    }
    {{ helperText }}
  </div>
</div>
